module.exports = __webpack_public_path__ + "static/media/edit-organization.453b66dc.svg";